<template>
  <AuthForm
    :can-submit="canBeSubmitted"
    :error="form.error"
    :submitted="form.submitted"
    type="login"
    @submit="submit"
  >
    <FormInput
      :label="$t('email')"
      :model-value="form.fields.email.value"
      name="email"
      :placeholder="$t('email')"
      type="email"
      @update:modelValue="(newValue) => (form.fields.email = newValue)"
    />
  </AuthForm>
</template>

<script>
import AuthForm from '@/components/form/auth/AuthForm.vue'
import { FormInput } from '@/components/form/fields'
import { AuthFormCanBeSubmittedMixin } from '@/components/form/mixins'

export default {
  name: 'AuthLoginForm',
  mixins: [AuthFormCanBeSubmittedMixin],
  components: { AuthForm, FormInput },
  data() {
    return {
      form: {
        error: null,
        fields: {
          email: {
            valid: false,
            value: null,
          },
        },
        submitted: false,
      },
    }
  },
  methods: {
    async submit() {
      this.form.error = null
      this.form.submitted = true
      const error = await this.$store.dispatch('login', { email: this.form.fields.email.value })

      this.form.submitted = false
      this.form.error = error
    },
  },
  watch: {
    'form.fields.email.value'() {
      this.form.error = null
    },
  },
}
</script>
